$(document).ready(function() {
    var video_trailer = $("#game-trailer").attr("src");
    var video_quest = $("#game-quest").attr("src");
    $(document).on('click', '.js-game-trailer-button', function() {
        $('body').addClass('is-modal-open');
        $('.js-game-trailer').addClass('show');
        $("#game-trailer")[0].src += "?autoplay=1";
    });
    $(document).on('click', '.js-game-trailer-close', function() {
        $("#game-trailer").attr("src", "");
        $("#game-trailer").attr("src", video_trailer);
        $('body').removeClass('is-modal-open');
        $('.js-game-trailer').removeClass('show');
    });

    $(document).on('click', '.js-game-quest-button', function() {
        $('body').addClass('is-modal-open');
        $('.js-game-quest').addClass('show');
        $("#game-quest")[0].src += "?autoplay=1";
    });
    $(document).on('click', '.js-game-quest-close', function() {
        $("#game-quest").attr("src", "");
        $("#game-quest").attr("src", video_quest);
        $('body').removeClass('is-modal-open');
        $('.js-game-quest').removeClass('show');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/game-trailer.js